import React from "react";
import Atletica from "../components/site/Atletica";

export default function AtleticaPage() {
  return (
    <div className="pt-20">
      <Atletica />
    </div>
  );
}
